import axios from "axios";

export const baseURL = "https://crmstaruante.herokuapp.com/api/";
// export const baseURL = "http://127.0.0.1:8000/api/";

const token = localStorage.getItem("token");

export const API = axios.create({
  baseURL: baseURL,
});

